<template>
  <!-- class="lg:flex flex-1" -->
  <Nav />
  <toTopComponent />
  <router-view class="mypage-main" />
  <Footer />
</template>

<script>
import Nav from "@/components/new/Nav.vue";
import toTopComponent from "@/components/toTopComponent.vue";
import Footer from "@/components/new/Footer.vue";

export default {
  name: "myPage",
  components: { Nav, toTopComponent, Footer },
};
</script>

<style>
.main {
  margin-top: var(--nav-height, 80px);
}
</style>
